import { render, staticRenderFns } from "./TestingSuits.vue?vue&type=template&id=7b5b7fd2&scoped=true&"
import script from "./TestingSuits.vue?vue&type=script&lang=js&"
export * from "./TestingSuits.vue?vue&type=script&lang=js&"
import style0 from "./TestingSuits.vue?vue&type=style&index=0&id=7b5b7fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b7fd2",
  null
  
)

export default component.exports